import {inject, Injectable, signal} from '@angular/core';
import {finalize, Observable} from 'rxjs';
import {
  ProjectCharterControllerService,
  ProjectCharterOverviewResponse,
  ProjectCharterOverviewUpsertRequest,
  ProjectCharterParametersResponse,
  ProjectCharterParametersUpsertRequest,
  ProjectCharterRolesAndStakeholdersResponse,
  ProjectCharterRolesAndStakeholdersUpsertRequest,
  ProjectCharterScopeResponse,
  ProjectCharterScopeUpsertRequest,
  ProjectTimeFrameResponse,
} from '@frontend/shared-api';
import {ProjectDataService} from '../../../../../../shared/services/project-data.service';

@Injectable({providedIn: 'root'})
export class Step12ProjectCharterService {
  private readonly api = inject(ProjectCharterControllerService);
  private readonly projectDataService = inject(ProjectDataService);
  readonly isLoading = signal(false);

  // TODO define other signals here instead of component?
  timeFrameData = signal<ProjectTimeFrameResponse[]>([]);

  loadCharter() {
    const projectId = this.projectDataService.getProjectId();
    if (projectId != null) {
      this.isLoading.set(true);
      this.api
        .getProjectCharter({projectId})
        .pipe(finalize(() => this.isLoading.set(false)))
        .subscribe({
          next: (data) => {
            this.timeFrameData.set(data.projectTimeFrames);
            // TODO set other values from this response instead making single requests for each
          },
        });
    }
  }

  getCharterOverview(projectId: number): Observable<ProjectCharterOverviewResponse> {
    return this.api.getCharterOverview({projectId});
  }

  saveCharterOverview(
    projectId: number,
    request: ProjectCharterOverviewUpsertRequest,
  ): Observable<ProjectCharterOverviewResponse> {
    return this.api.upsertCharterOverview({
      projectId: projectId,
      projectCharterOverviewUpsertRequest: request,
    });
  }

  getCharterScope(projectId: number): Observable<ProjectCharterScopeResponse> {
    return this.api.getCharterScope({projectId});
  }

  saveCharterScope(
    projectId: number,
    request: ProjectCharterScopeUpsertRequest,
  ): Observable<ProjectCharterScopeResponse> {
    return this.api.upsertCharterScope({
      projectId: projectId,
      projectCharterScopeUpsertRequest: request,
    });
  }

  getCharterParameters(projectId: number): Observable<ProjectCharterParametersResponse> {
    return this.api.getCharterParameters({projectId});
  }

  saveCharterParameters(
    projectId: number,
    request: ProjectCharterParametersUpsertRequest,
  ): Observable<ProjectCharterParametersResponse> {
    return this.api.upsertCharterParameters({
      projectId: projectId,
      projectCharterParametersUpsertRequest: request,
    });
  }

  getCharterRolesAndStakeholders(
    projectId: number,
  ): Observable<ProjectCharterRolesAndStakeholdersResponse> {
    return this.api.getCharterRolesAndStakeholders({projectId});
  }

  saveCharterRolesAndStakeholders(
    projectId: number,
    request: ProjectCharterRolesAndStakeholdersUpsertRequest,
  ): Observable<ProjectCharterRolesAndStakeholdersResponse> {
    return this.api.upsertCharterRolesAndStakeholders({
      projectId: projectId,
      projectCharterRolesAndStakeholdersUpsertRequest: request,
    });
  }
}
